import { render, staticRenderFns } from "./FullPageMediaPreview.vue?vue&type=template&id=09f3965f&"
import script from "./FullPageMediaPreview.vue?vue&type=script&lang=js&"
export * from "./FullPageMediaPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports